export default __webpack_public_path__ + "static/media/add.fc88f2ab.svg";